import React from 'react';
import LazyImage from '../LazyImage';
import './Specialist.css';
import salaryIcon from '../../assets/icons/specialist/salary.png';
import selfIcon from '../../assets/icons/specialist/self.png';
import studentIcon from '../../assets/icons/specialist/student.png';
import investorIcon from '../../assets/icons/specialist/investor.png';
import medicalIcon from '../../assets/icons/specialist/medical.png';
import cgtIcon from '../../assets/icons/specialist/cgt.png';
import cryptoIcon from '../../assets/icons/specialist/crypto.png';
import returnIcon from '../../assets/icons/specialist/return.png';

const Specialist = () => {
    const specialistData = [
        {
            id: 1,
            icon: salaryIcon,
            title: "Salaried Employees",
            description: "We handle tax returns for full-time, part-time, or casual workers. All income is declared correctly, and eligible work-related deductions are applied to maximise your refund."
        },
        {
            id: 2,
            icon: selfIcon,
            title: "Self-Employed & Sole Traders",
            description: "From income reporting to deductions, we simplify tax for freelancers and sole traders. Our expert support keeps your business compliant and stress-free year-round."
        },
        {
            id: 3,
            icon: studentIcon,
            title: "Students & International Students",
            description: "We offer affordable tax services for students, covering part-time income and study-related claims. Quick, easy, and focused on getting you the best refund possible."
        },
        {
            id: 4,
            icon: investorIcon,
            title: "Property Investors",
            description: "We manage tax reporting for rental properties — including depreciation, interest deductions, and negative gearing — to maximise returns while meeting ATO standards."
        },
        {
            id: 5,
            icon: medicalIcon,
            title: "Medical & Allied Health Professionals",
            description: "Specialised tax returns for doctors and health professionals. We handle allowances, equipment, travel, and CPD claims to ensure compliance and maximum deductions."
        },
        {
            id: 6,
            icon: cgtIcon,
            title: "Capital Gains Tax (CGT)",
            description: "Sold shares or property? We calculate CGT, apply exemptions, and ensure accurate reporting to help minimise your tax on investment gains."
        },
        {
            id: 7,
            icon: cryptoIcon,
            title: "Cryptocurrency Transactions",
            description: "Whether you trade, stake, or mine crypto, we report your transactions correctly and align your records with ATO crypto tax guidelines."
        },
        {
            id: 8,
            icon: returnIcon,
            title: "Amended Returns",
            description: "Made a mistake or forgot income? We lodge accurate amendments through official ATO processes to correct your return with minimal disruption."
        }
    ];

    return (
        <section className="specialist">
            <div className="specialist-container">
                <div className="specialist-content">
                    <div className="specialist-header">
                        <div className="specialist-tag">Specialist Return Types We Handle</div>
                        <h2 className="specialist-title">
                        Tailored <span className="text-primary">Tax Solutions</span><br />
                        <span className="text-dark">for Every Individual</span>
                        </h2>
                        <p className="specialist-description">
                        We go beyond basic tax filing. Our expert team ensures your return is accurate, 
                        compliant, and optimized for the best possible outcome — with complete support 
                            from start to finish.
                        </p>
                    </div>

                    <div className="specialist-cards">
                        {specialistData.map((specialist) => (
                            <div key={specialist.id} className="specialist-card">
                                <div className="specialist-icon">
                                    <LazyImage src={specialist.icon} alt={specialist.title} />
                                </div>
                                <div className="specialist-content">
                                    <h3 className="specialist-title">{specialist.title}</h3>
                                    <p className="specialist-description">{specialist.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Specialist;